import { Component, Input } from '@angular/core';

@Component({
  selector: 'sl25',
  templateUrl: './sl25.component.html',
  styleUrls: ['./sl25.component.scss']
})
export class SL25Component {
  @Input() package: any;
}
